import { colors, styled, SearchField as ComponentsSearchField } from "@tm/components"

export const SearchField = styled(ComponentsSearchField)(({ theme }) => ({
    width: 350,
    ".MuiInputBase-root": {
        borderColor: colors.grey[400],
        color: theme.colors?.dark ?? theme.palette.common.black,
    },
}))
